import React from "react";
import { Layout } from "antd";
import { FlowstationFieldList } from "./FlowstationFieldList";
import { MappingDialog } from "./MappingDialog";

const { Content } = Layout;
export const FlowstationFieldBaseView = () => {
  return (
    <Layout>
      <Content>
        <Layout style={{ background: "#fff" }}>
         
          <Content style={{ background: "#fff", paddingLeft: "20px",  }}> <FlowstationFieldList />
          <MappingDialog/>
          </Content>
        </Layout>
      </Content>
    </Layout>
  );
};

